import 'firebase/messaging';
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { AnalyticsService } from '../analytics/analytics.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class WebPushNotificationService {
  public readonly tokenReceived: Subject<string> = new Subject();

  constructor(
    private messaging: AngularFireMessaging,
    private _analyticsService: AnalyticsService,
  ) {
    if (Capacitor.getPlatform() !== 'web') {
      return;
    }

    if (new URLSearchParams(location.search).has('from_push')) {
      setTimeout(() => {
        _analyticsService.pushNotificationClicked();
      }, 5000);
    }

    if (this.isPermissionGranted()) {
      this.subscribeToPushes();
    }
  }

  public requestPermission(): Observable<boolean> {
    return this.messaging.requestPermission.pipe(
      switchMap((permission) => {
        if (permission === 'granted') {
          return this.messaging.tokenChanges.pipe(
            filter((token) => !!token),
            map((token) => {
              console.log('Permission granted! Save to the server!', token);
              this._analyticsService.subscribedToPushNotifications({
                platform: 'web',
              });
              this.tokenReceived.next(token);
              this.subscribeToPushes();
              return true;
            }),
          );
        } else {
          console.log('Permission denied or dismissed');
          return of(false);
        }
      }),
      catchError((error) => {
        console.log('Error requesting permission', error);
        return of(false);
      }),
    );
  }

  public isPermissionGranted(): boolean {
    return (
      typeof Notification !== 'undefined' &&
      Notification.permission === 'granted'
    );
  }

  public canRequestPermission(): boolean {
    return (
      typeof Notification !== 'undefined' &&
      Notification.permission === 'default'
    );
  }

  private subscribeToPushes(): void {
    this.messaging.messages.subscribe((payload: any) => {
      console.log('messaging payload', payload);
      this._analyticsService.webPushReceived(payload.fcmOptions || {});
      window.location = payload.fcmOptions.link;
    });
  }
}
